import type { RouteMode } from "../../router";
import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isIndianPokerV2Path(pathname = currentPathname()): boolean {
  return isPlatformGamePath("indian-poker", pathname);
}

export function resolveIndianPokerRouteMode(
  pathname = currentPathname(),
): RouteMode {
  return isIndianPokerV2Path(pathname) ? "v2" : "legacy";
}

export function resolveIndianPokerGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isIndianPokerV2Path(pathname) ? "game-platform" : "legacy";
}
